import React from 'react';
import '../styles/LocalTaxi.css';

const BENEFITS = [
  { icon: 'fa-snowflake-o', title: 'Comfortable AC Cabs' },
  { icon: 'fa-road', title: 'Flexible Local Travel' },
  { icon: 'fa-calendar-check-o', title: 'Easy Booking' },
];

const bookLocalTaxi = (event) => {
  const target = document.getElementById('home-booking');
  if (!target) return;
  event.preventDefault();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  if (window.history && window.history.replaceState) {
    window.history.replaceState(null, '', '#home-booking');
  }
};

const LocalTaxi = () => (
  <section className="local-taxi" aria-labelledby="local-taxi-heading">
    <div className="container">
      <div className="local-taxi-card">
        <div className="local-taxi-copy">
          <h2 id="local-taxi-heading">Local Taxi in Coimbatore</h2>
          <p>
            Need a cab within Coimbatore? Travel comfortably for shopping, business meetings, hospital visits and everyday city journeys.
          </p>
          <ul className="local-taxi-benefits">
            {BENEFITS.map((benefit) => (
              <li key={benefit.title}>
                <i className={`fa ${benefit.icon}`} aria-hidden="true"></i>
                <span>{benefit.title}</span>
              </li>
            ))}
          </ul>
          <a className="local-taxi-cta" href="#home-booking" onClick={bookLocalTaxi}>Book a Local Taxi</a>
        </div>
      </div>
    </div>
  </section>
);

export default LocalTaxi;
